export const AUTH_API_HOST =
  process.env.REACT_APP_AUTH_API_HOST ?? ''
